<script setup lang="ts">

import { useGameStore } from '@/stores/gameStore.ts'
import {computed} from "vue";
import {usePlayerRelationStore} from "@/stores/playerRelations.ts";
import PatreonIcon from '@/components/Elements/Images/Icons/PatreonIcon.vue';

const props = defineProps({
  playerId: {
    type: Number,
    required: true
  },
  disableModal: {
    type: Boolean,
    default: false
  },
  showPatreonIcon: {
    type: Boolean,
    default: false
  }
});

const gameStore = useGameStore();
const playerRelationStore = usePlayerRelationStore();

const data = computed(() => {
  if(props.playerId == gameStore.player?.id) {
    return {
      relation: 'player',
      name: gameStore.player?.nickName,
      patreonTier: gameStore.player?.patreonTier
    }
  }
  return playerRelationStore.findRelationByPlayerId(Number(props.playerId));
});

const isOnline = computed(() => {
  if (props.playerId === gameStore.player?.id) {
    return true;
  }
  return playerRelationStore.isPlayerOnline(props.playerId);
});

const openModal = () => {
  gameStore.modalType = 'requestAudience';
  gameStore.modalData = {relation: data};
}

</script>

<template>
  <span v-if="data?.relation == 'neutral'" class="text-yellow-400" :class="{ 'cursor-pointer': !disableModal }" @click="!disableModal && openModal()">
    {{ data?.name }}
    <PatreonIcon v-if="showPatreonIcon" :patreon-tier="data?.patreonTier" :size="12" />
  </span>
  <span v-else-if="data?.relation == 'player'" class="text-green-500">
    {{ data?.name }}
    <span class="material-symbols-outlined online-indicator" :class="isOnline ? 'text-green-500' : 'text-gray-600'" :style="{ fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 16` }" :title="isOnline ? 'Player is online' : 'Player is not online'">circle</span>
    <PatreonIcon v-if="showPatreonIcon" :patreon-tier="data?.patreonTier" :size="12" />
  </span>
  <span v-else-if="data?.relation == 'enemy'" class="text-red-500" :class="{ 'cursor-pointer': !disableModal }" @click="!disableModal && openModal()">
    {{ data?.name }}
    <PatreonIcon v-if="showPatreonIcon" :patreon-tier="data?.patreonTier" :size="12" />
  </span>
  <span v-else-if="data?.relation == 'friend'" class="text-purple-500" :class="{ 'cursor-pointer': !disableModal }" @click="!disableModal && openModal()">
    {{ data?.name }}
    <span class="material-symbols-outlined online-indicator" :class="isOnline ? 'text-green-500' : 'text-gray-600'" :style="{ fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 16` }" :title="isOnline ? 'Player is online' : 'Player is not online'">circle</span>
    <PatreonIcon v-if="showPatreonIcon" :patreon-tier="data?.patreonTier" :size="12" />
  </span>
  <span v-else-if="data?.relation == 'ally'" class="text-cyan-500" :class="{ 'cursor-pointer': !disableModal }" @click="!disableModal && openModal()">
    {{ data?.name }}
    <span class="material-symbols-outlined online-indicator" :class="isOnline ? 'text-green-500' : 'text-gray-600'" :style="{ fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 16` }" :title="isOnline ? 'Player is online' : 'Player is not online'">circle</span>
    <PatreonIcon v-if="showPatreonIcon" :patreon-tier="data?.patreonTier" :size="12" />
  </span>
  <span v-else-if="data?.relation == 'alliance'" class="text-blue-500" :class="{ 'cursor-pointer': !disableModal }" @click="!disableModal && openModal()">
    {{ data?.name }}
    <span class="material-symbols-outlined online-indicator" :class="isOnline ? 'text-green-500' : 'text-gray-600'" :style="{ fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 16` }" :title="isOnline ? 'Player is online' : 'Player is not online'">circle</span>
    <PatreonIcon v-if="showPatreonIcon" :patreon-tier="data?.patreonTier" :size="12" />
  </span>
  <span v-else-if="data?.relation == 'unknown'" class="text-gray-500">
    Nobody
  </span>
</template>

<style scoped lang="scss">
.online-indicator {
  font-size: 8px;
  vertical-align: middle;
  margin-left: 4px;
}
</style>